import { Box, BoxProps } from "@aksara-ui/react";
import { InputGroup } from "components/Form/InputGroup";
import { InputSelect } from "components/Form/InputSelect";
import { InputPrefix } from "components/Input";
import * as React from "react";

export interface FilterPageHeaderProps extends BoxProps {
  /** callback function onClear action */
  onClearFilter?: () => void;
  /** callback function onSearch action  */
  onSearch?: React.ChangeEventHandler<HTMLInputElement>;
  // TODO filter panel is not implemented yet
  /** callback function onFilter action  */
  actions?: React.ReactNode;
  /** callback function onChangeOrder action  */
  onChangeOrder?: (
    orderOption: Record<string, { label: string; value: string }>
  ) => void;
  /** order config, for now maximum order config is 2   */
  orderByOptions?: {
    key: string;
    label: string;
    options: { label: string; value: string }[];
  }[];
  /** filter data used to show filter tag   */
  filterData?: { label: string; value: string }[];
  /** callback function when one of filter tag was removed   */
  onRemoveFilter?: (data: { label: string; value: string }) => void;
}
export const MAX_TAG_FILTER = 6;
export const MAX_ORDER_OPTIONS = 2;

const FilterPageHeader: React.FC<FilterPageHeaderProps> = ({
  onChangeOrder,
  orderByOptions,
  actions,
}) => {
  const [orderOption, setOrderOption] = React.useState<
    Record<string, { label: string; value: string }>
  >({});
  React.useEffect(() => {
    if (orderOption && onChangeOrder) {
      onChangeOrder(orderOption);
    }
  }, [orderOption]);

  const renderOrderOptions = () => {
    if (!orderByOptions?.length) {
      return null;
    }
    return (
      <Box display="flex" flexDirection="row" marginTop={["md", 0]}>
        {orderByOptions.slice(0, MAX_ORDER_OPTIONS).map((orderItem) => {
          return (
            <Box
              marginLeft={["xxs"]}
              key={orderItem.key}
              data-testid="orderOption"
            >
              <InputGroup width="100%" maxWidth={280}>
                <InputPrefix zIndex={1}>Filter by</InputPrefix>
                <InputSelect
                  selectedItem={orderOption[orderItem.key]}
                  width="260px"
                  maxHeight={"520px"}
                  placeholder={orderItem.label}
                  itemToString={(item) => (item ? `${item.label}` : "")}
                  itemValue={(item) => (item ? `${item.value}` : "")}
                  handleSelectedItemChange={({ selectedItem }) => {
                    if (selectedItem) {
                      setOrderOption({
                        ...orderOption,
                        [orderItem.key]: selectedItem,
                      });
                    }
                  }}
                  items={orderItem.options}
                  paddingLeft={"60px"}
                />
              </InputGroup>
            </Box>
          );
        })}
      </Box>
    );
  };
  return (
    <>
      <Box
        display={["block", "flex"]}
        alignItems={[null, "center"]}
        justifyContent={[null, "space-between"]}
      >
        <Box
          display={["block", "flex"]}
          justifyContent={[null, "space-between"]}
        >
          {renderOrderOptions()}
        </Box>
        {actions && <Box marginTop={["md", 0]}>{actions}</Box>}
      </Box>
    </>
  );
};

export default FilterPageHeader;
